import type { FaireProductEntity } from "../../entity_types/product";

export const p_z35vwenx85: FaireProductEntity = {
  token: "p_z35vwenx85",
  type: "product",
  name: "Umami Bomb - Oso Rojo Hot Sauce, 4oz",
  brandToken: "b_5g4fjz73el",
  brandName: "Oso Rojo Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/b1396b87649fe8617e8664119e93232ca76e8cc23b0a3c6cdd0be656c288a47b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62813fcdaebd7cde467655461a48513b4fed3576fc470a6f72bdd07ac55cb31e.jpeg",
  ],
  priceDollars: 5,
  description:
    "Umami is that rich, deep, meaty intensity that you get from certain foods. Umami comes from the Japanese word for delicious, umai, and that is exactly what this sauce is. Roasted veggies, dried chiles, dried mushrooms and tamari come together to create a depth of flavor in this bottle, similar to a mole sauce. Try out Umami Bomb on chicken wings, ramen or even mac and cheese.\n\nSpice Level: Mild to Medium\n",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:10.248Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
